export default __webpack_public_path__ + "static/media/litho-landing-page-banner-img-01.db5d3634.jpg";